import React from 'react';
import { Box, useTheme } from '@mui/material';

import type { InputFooterProps } from './InputFooter.types';

/**
 * Consistent footer wrapper for chat input areas
 * Provides consistent styling and elevation
 *
 * @example
 * ```tsx
 * <InputFooter>
 *   <ChatInput onSend={handleSend} />
 * </InputFooter>
 * ```
 */
export const InputFooter: React.FC<InputFooterProps> = ({
  children,
  elevation = true,
  borderColor,
  className,
}) => {
  const theme = useTheme();

  return (
    <Box
      className={className}
      sx={{
        p: 2,
        borderTop: 1,
        borderColor: borderColor || 'divider',
        bgcolor: 'white',
        ...(elevation && {
          boxShadow: '0 -2px 10px rgba(0, 0, 0, 0.05)',
        }),
      }}
    >
      {children}
    </Box>
  );
};
